module.exports = __webpack_public_path__ + "vyhlazeni-vrasek-injekcni-metody_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/laserova-estetika/vyhlazeni-vrasek-injekcni-metody_1_before_tn.jpg
// module id = 1486
// module chunks = 0